import { Award } from "lucide-react";
import { NAV_LINKS, EMAIL, PHONE, PHONE_HREF } from "./data/content";
import { useGoToSection } from "../lib/useGo";
import Logo from "./Logo";

export const Footer = () => {
  const go = useGoToSection();
  return (
  <footer className="border-t border-white/10 bg-surface/70">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
      <p className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="footer-headline">
        Tomorrow&rsquo;s place for property<span className="text-gold-light">.</span>
      </p>

      <div className="mt-12 grid gap-10 border-t border-white/10 pt-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            The central operating platform for agents, teams and independent real estate brands —
            Australia-wide.
          </p>
          <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-3.5 py-1.5">
            <Award className="h-3.5 w-3.5 text-gold-light" />
            <span className="label-mono !text-[9.5px]">REB &amp; RET 2026 Boutique Network of the Year</span>
          </p>
        </div>

        <div>
          <p className="label-mono !text-slate-500">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.slice(0, 5).map((l) => (
              <li key={l.id}>
                <a
                  href={`/#${l.id}`}
                  onClick={(e) => {
                    go(l.id, "footer")(e);
                  }}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="label-mono !text-slate-500">Contact</p>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
            <li>
              <a href={PHONE_HREF} data-testid="footer-contact-phone" className="transition-colors hover:text-gold-light">
                {PHONE}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} data-testid="footer-contact-email" className="transition-colors hover:text-gold-light">
                {EMAIL}
              </a>
            </li>
          </ul>
          <p className="label-mono !text-slate-500 mt-7">Learn more</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <a href="/real-estate-franchise-alternative" data-testid="footer-link-franchise" className="text-sm text-slate-400 transition-colors hover:text-white">
                Real estate franchise alternative
              </a>
            </li>
            <li>
              <a href="/real-estate-business-support" data-testid="footer-link-support" className="text-sm text-slate-400 transition-colors hover:text-white">
                Real estate business support
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="label-mono !text-slate-500">Confidentiality</p>
          <p className="mt-4 text-xs leading-relaxed text-slate-500">
            Every enquiry is handled in confidence by Agency HQ&rsquo;s recruitment team. We never contact
            your current agency.
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-600">© {new Date().getFullYear()} Agency HQ. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          Retain up to 95% · No establishment costs · Australia-wide
        </p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
